import { Component, OnInit } from '@angular/core';
import {LangRepository} from '../../model/lang.repository';

@Component({
  selector: 'app-topline',
  templateUrl: './topline.component.html',
  styleUrls: ['./topline.component.css']
})
export class ToplineComponent implements OnInit {

  caret: boolean = false;

  constructor(public langRepository: LangRepository ) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/search/top-line/topline.component.ts